import {
    LeagueNavRequestResolver,
    WidgetZonesRequestResolver,
    SportEvent,
    League,
    SportsbooksEventConstructor,
    Widget,
    SportsbookLeagueConstructor,
    Sport
} from '@draftkings/dk-data-layer';
import { BaseRetrieverOptions, IConditionManager, ICondition } from '@draftkings/widgets-core';
import { SportSliderStatusError } from '../external';
import { ProductConfig, TrackEventFunction } from '@draftkings/sportsbook-common-contracts';

export const ConditionKeys = ['Retriever'] as const;

export type SubscriptionPartial = {
    entity: string;
    query: string;
};

export type SherpaData = {
    events: Map<string, SportEvent>;
    leagues: Map<string, League>;
    sports: Map<string, Sport>;
};

export type ClankData = {
    events: Map<string, SportEvent>;
    leagues: Map<string, League>;
};

export type ClankОptions = BaseRetrieverOptions<ClankData> & {
    widgetZonesRequestResolver: WidgetZonesRequestResolver;
    SportsbookEvent: SportsbooksEventConstructor;
    condition: IConditionManager<typeof ConditionKeys> & ICondition;
    widgets: Widget[];
    zoneId: string;
    logError: (error: SportSliderStatusError) => void;
    trackEvent: TrackEventFunction;
    consumerVersion: string;
    productConfig: ProductConfig;
};

export type SherpaOptions = BaseRetrieverOptions<SherpaData> & {
    leagueNavRequestResolver: LeagueNavRequestResolver;
    SportsbookLeague: SportsbookLeagueConstructor;
    condition: IConditionManager<typeof ConditionKeys> & ICondition;
    leagueId: string;
    logError: (error: SportSliderStatusError) => void;
    trackEvent: TrackEventFunction;
    consumerVersion: string;
    productConfig: ProductConfig;
};
